import React from 'react';

import ImageInputV1 from './image_input_v1';
import ImageInputV2 from './image_input_v2';

export default ({ version, ...props }) => {
  if (version === 2) return <ImageInputV2 {...props} />;
  return <ImageInputV1 {...props} />;
};
